export default __webpack_public_path__ + "static/media/villaScassi.102d3bfe.png";